// removed by extract-text-webpack-plugin
module.exports = {"title":"aqz-ruSS8kZjCWfMSFCHi","tagListStr":"_13QB5W2AFgidV4PXHck8At","chtName":"_2vrj7jygYOh6w4_xEnWJi7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/content-title/ContentTitle.css
// module id = 374
// module chunks = 0